<template>
  <div class="row">
    <div class="col-md-12">
 
      <b-table small
      :fields="tableHead"
      :items="currencies"
      responsive="sm"
    >
        <!-- A custom formatted column -->
        <template #cell(code)="data">
          {{ data.item.code.toUpperCase() }}
        </template>
        <template #cell(exchange)="data">
        {{ numberFormat(data.item.exchange)  }}
        </template>
        <template #cell(exchangeMXN)="data">
        {{ numberFormat(data.item.exchange / exchangeMXN.exchange)  }}
        </template>
      </b-table>
   
    </div>
  </div>
</template>
<script>
  import {NumberFormat} from "../../helpers/NumberFormat"
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
  export default {
    name:'Currencies',
    components:{FontAwesomeIcon},
    props:['currencies'],
    data() {
      return {
        loading:false,
        exchangeMXN: this.currencies.find(element => element.code == 'mxn'),
        tableHead: [
          { key: 'code', label: 'Code' },
          { key: 'exchange', label: 'Tipo de Cambio a USD' },  
          { key: 'exchangeMXN', label: 'Tipo de Cambio a MXN' },
          { key: 'name', label:'Divisa'}
        ]
      }
    },
    methods:{
      numberFormat(number) {
        return NumberFormat.format(parseFloat(number), 6, ',', '.')
      },
      getZoneName(zone){
        if (zone == 'foreign') {
          return 'Foraneo'
        }
        return 'Local'
      }
    }
  }
</script>